import { render, staticRenderFns } from "./OrdenList.vue?vue&type=template&id=5a8487de&scoped=true&"
import script from "./OrdenList.vue?vue&type=script&lang=js&"
export * from "./OrdenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8487de",
  null
  
)

export default component.exports